import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterCateg',
  standalone: true
})
export class FilterCategPipe implements PipeTransform {
  transform(value: any, activeCateg: string) {
    if (!activeCateg) {
      return null
    }
    else {
      let arrayCopy = [...value];
      value = arrayCopy.filter((data: any) => {
        return data.subCategoryName == activeCateg
      });
      return value[0].products
    }
  }
}
